/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { riskOverviewGet } from "../funcs/riskOverviewGet.js";
import { riskOverviewUserBreakdown } from "../funcs/riskOverviewUserBreakdown.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { RiskOverviewResult } from "../models/components/riskoverviewresult.js";
import { RiskUserBreakdownResult } from "../models/components/riskuserbreakdownresult.js";
import {
  GetRiskOverviewRequest,
  GetRiskOverviewSecurity,
} from "../models/operations/getriskoverview.js";
import {
  GetRiskUserBreakdownRequest,
  GetRiskUserBreakdownSecurity,
} from "../models/operations/getriskuserbreakdown.js";
import { unwrapAsync } from "../types/fp.js";

export class Overview extends ClientSDK {
  /**
   * getRiskOverview risk
   *
   * @remarks
   * Get risk overview metrics and trend data for the current project.
   */
  async get(
    request?: GetRiskOverviewRequest | undefined,
    security?: GetRiskOverviewSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RiskOverviewResult> {
    return unwrapAsync(riskOverviewGet(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getRiskUserBreakdown risk
   *
   * @remarks
   * Per-user breakdowns of findings by category and by rule_id within a time window. Powers the risk panels on identity pages.
   */
  async userBreakdown(
    request: GetRiskUserBreakdownRequest,
    security?: GetRiskUserBreakdownSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RiskUserBreakdownResult> {
    return unwrapAsync(riskOverviewUserBreakdown(
      this,
      request,
      security,
      options,
    ));
  }
}
